import { render } from 'react-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { setSentryContext, startSentry } from '@utils/sentry';

import { App } from 'components/App';

import { config } from './app-config';

import '@styles/variables.css';
import '@styles/reset.css';

if (config.SENTRY_URL) {
  startSentry(config.SENTRY_URL);
  setSentryContext('build', {
    buildDate: process.env.__BUILD_DATE__,
    buildRef: process.env.__BUILD_REF__,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
  document.getElementById('root'),
);
